import { render, staticRenderFns } from "./configCard.vue?vue&type=template&id=52f3b125&scoped=true&"
import script from "./configCard.vue?vue&type=script&lang=js&"
export * from "./configCard.vue?vue&type=script&lang=js&"
import style0 from "./configCard.vue?vue&type=style&index=0&id=52f3b125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f3b125",
  null
  
)

export default component.exports